module.exports = __webpack_public_path__ + "img/icon_point.b3742812.png";